import { Button, FloatingLabel, Form, Spinner } from "react-bootstrap"
import { useForm } from "react-hook-form"
// import { IPerson } from "../../interface/IPerson"
import { useDeleteOrderItemMutation, useGetCertificateDataMutation, useGetOrderDetailsDataMutation, useGetOrderItemsMutation, useGetOrderLinkMutation, useGetPersonWhoamiQuery, useGetSessionAssignmentsMutationMutation, usePostAddCertToOrderMutation, usePostCertificateFindMutation, usePostPersonIdAgreementsMutation, usePostSetOrderStatusMutation, usePutPersonMutation } from "../../features/CallTPApi"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { IOrder } from "../../interface/IOrder"
import { IPerson } from "../../interface/IPerson"
import { useDispatch } from "react-redux"
import { setAlertMsgStore } from "../../features/alertMsgSlisce"
import { setDeleteItemsStore } from "../../features/deleteItemsSlice"
import { setOrderInStore } from "../../features/orderSlice"
import { useSelector } from "react-redux"
import { shallowEqual } from "react-redux"
import { ICategoryAssignments } from "../../interface/ICategoryAssignments"
import { ISector } from "../../interface/ISector"
import { ISeat } from "../../interface/ISeat"
import { ILocation } from "../../interface/ILocation"
import { setSessionAssignmentsStore } from "../../features/sessionAssignmentsSlice"
import { ISession } from "../../interface/ISession"
import { setSessionItemsInStore } from "../../features/sessionItemsSlice"
import { FullScreenLoader } from "../UI/FullScreenLoader"
import { useTokenTP } from "../../features/useTokenTP"
// import { ym } from "react-metrika"
import PermissionControl from "../../PermissionControl/PermissionControl"
import { ICertificate } from "../../interface/ICertificate"
import { ITenant } from "../../interface/ITenant"
import { IOrderDetails, IPayment } from "../../interface/IOrderDetails"
import { setPrePaymantsInStore } from "../../features/prePaymantsSlice"
import { CertPament } from "./CertPayment"
import { Link } from "react-router-dom"




const CertForm = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm<ICertificate>()
    const order = useSelector((state: any) => state.order) as IOrder;
    const basket = useSelector((state: any) => state.basket) as ISeat[]
    const sessionAssignments = useSelector((state: any) => state.sessionAssignments, shallowEqual) as ICategoryAssignments[];
    const location = useSelector((state: any) => state.locationScheme, shallowEqual) as ILocation;
    const tenant = useSelector((state: any) => state.tenant) as ITenant;
    const [showCertForm, setShowCertForm] = useState<boolean>(false)
    const [postCertificateFind, { isLoading: isFindLoading }] = usePostCertificateFindMutation()
    const [getCertificate, { isLoading }] = useGetCertificateDataMutation()
    const [getOrderDetails, { isLoading: isLoadingOrderDetails }] = useGetOrderDetailsDataMutation()
    const prePaymants = useSelector((state: any) => state.prePaymants) as IPayment[]
    const dispatch = useDispatch()
    const [summ, setSumm] = useState<number>(0)
    const [postAddCertToOrder] = usePostAddCertToOrderMutation()

    const getCertInOrder = () => {
        getOrderDetails({ id: order.id, tenantId: '621da32c-a4a9-400f-be33-73fdcc20e12f' }).then((r: any) => {
            if (r) {
                const orderData = { ...r.data } as IOrderDetails
                dispatch(setPrePaymantsInStore(orderData.payments as any))
            }
        })
    }

    useEffect(() => {
        if (order) {
            // console.log(order)
            getCertInOrder()
        }
    }, [order])

    useEffect(() => {
        if (!location) {
            return;
        }
        if (!basket) {
            return;
        }
        const newbasketItems = basket.map(item => {
            const itemAssignment = sessionAssignments.find((cat: ICategoryAssignments) => cat.targetId === item.id) as ICategoryAssignments;
            const sector = location.sectors.find((sector: ISector) => sector.seats.some((seat: ISeat) => seat.id === item.id));
            const seat = sector ? sector.seats.find((seat: ISeat) => seat.id === item.id) : undefined;
            return {
                id: item.id,
                price: itemAssignment.price,
                color: itemAssignment.color ?? "black",
                categoryName: itemAssignment.name,
                row: seat ? seat.row : undefined,
                seat: seat ? seat.place : undefined,
                quantity: 1,
                priceCategoryAssignmentId: itemAssignment.id,
                priceCategoryTarget: 3
            };
        });
        setSumm(newbasketItems.reduce((sum, item) => sum + item.price * item.quantity, 0))
    }, [basket])

    useEffect(() => {
        if (prePaymants) {
            console.log(prePaymants)
        }
    }, [prePaymants])

    const calcAmount = (certAmount: number) => {
        if (certAmount > summ) {
            return certAmount - (certAmount - summ);
        }
        return certAmount;
    }

    const getCert = (data: ICertificate) => {

        postCertificateFind(data).then((res: any) => {
            if (res.data) {
                // console.log(res.data)
                getCertificate(res.data.certificateId).then((res: any) => {
                    if (res.error) {
                        const errorData = res.error as any
                        dispatch(setAlertMsgStore({ title: `(Status error: ${errorData.data.status}), ${errorData.data.title}`, variant: "danger" } as any))
                    }
                    if (res.data) {
                        reset()
                        const body = {
                            certificateNumber: data.certificateNumber,
                            pinCode: data.pinCode,
                            amount: calcAmount(res.data.amount),
                            id: order.id
                        }
                        console.log(body)
                        postAddCertToOrder(body).then(() => {
                            getCertInOrder()
                        })
                    }
                })
            }
            if (res.error) {
                if (res.error) {
                    const errorData = res.error as any
                    console.log(errorData)
                    if (errorData.data.status === 404) {
                        dispatch(setAlertMsgStore({ title: `Сертификат не найден в системе либо указаны неверные данные карты.`, variant: "danger" } as any))
                        return;
                    }
                    dispatch(setAlertMsgStore({ title: `(Status error: ${errorData.data.status}), ${errorData.data.title}`, variant: "danger" } as any))
                }
            }

        })
    }
    return (
        <div className="mt-3 mb-3">
            {(prePaymants && prePaymants.length > 0) ?
                <div className="d-grid gap-2">
                    {prePaymants.map((payment) =>
                        <CertPament key={payment.id} payment={payment} />
                    )}
                </div>
                :
                <>
                    {(isLoading || isFindLoading || isLoadingOrderDetails) && <FullScreenLoader message="Получение данных сертификата..." />}
                    {!showCertForm ?
                        <div className="d-grid mt-2 mb-2">
                            <Button variant="outline-dark" size="sm" onClick={() => setShowCertForm(true)}>Использовать сертификат</Button>
                        </div>
                        :
                        <Form className="justify-content-center form-signin" onSubmit={handleSubmit(getCert)}>
                            <div className="shadow">
                                <FloatingLabel label="Номер сертификата">
                                    <Form.Control
                                        isInvalid={errors?.certificateNumber?.message ? true : false}
                                        className="topInput" placeholder="Номер сертификата" {...register("certificateNumber", { required: { value: true, message: "Укажите номер сертификата" } })} />
                                </FloatingLabel>
                                <FloatingLabel label="Пин-код">
                                    <Form.Control
                                        isInvalid={errors?.pinCode?.message ? true : false}
                                        className="bottomInput" type="string" placeholder="Пин-код" {...register("pinCode", { required: { value: true, message: "Укажите пин-код" }, })} />
                                </FloatingLabel>
                            </div>
                            <Button type="submit" className="w-100 shadow" variant="outline-success">Добавить</Button>
                        </Form>
                    }
                </>
            }
        </div>

    )
}

export const PersonForm = () => {
    const { logOutTP } = useTokenTP()

    const [disabledForm, setDisabledForm] = useState<boolean>(false)
    const [postSetOrderStatus, { isLoading: isLoadingOrderStatus }] = usePostSetOrderStatusMutation()
    const [putPerson, { isLoading: isLoadingPutPerson }] = usePutPersonMutation()
    const { data, isLoading } = useGetPersonWhoamiQuery()
    const [getOrderLink, { isLoading: isLoadingGetOrderLink }] = useGetOrderLinkMutation()
    const [getOrderItems] = useGetOrderItemsMutation()
    const navigate = useNavigate()
    const [postPersonIdAgreements] = usePostPersonIdAgreementsMutation()

    const [isLoadingBank, setIsLoadingBank] = useState<boolean>(false)
    const session = useSelector((state: any) => state.session) as ISession
    const basket = useSelector((state: any) => state.basket, shallowEqual) as any[];
    const location = useSelector((state: any) => state.locationScheme, shallowEqual) as ILocation;
    const sessionAssignments = useSelector((state: any) => state.sessionAssignments, shallowEqual) as ICategoryAssignments[];
    const [getSessionAssignmentsMutation] = useGetSessionAssignmentsMutationMutation()
    const [deleteOrderItem] = useDeleteOrderItemMutation()

    // const order = JSON.parse(localStorage.getItem('order') as string) as IOrder
    const order = useSelector((state: any) => state.order) as IOrder
    const dispatch = useDispatch()
    // const [getOrder, {isLoading: isLoadingOrder }] = useGetOrderMutation()

    const { register, handleSubmit, setValue, formState: { errors } } = useForm<any>()

    // const {data, isLoading} = useGetPersonQuery(personId)

    const submit = async (data: IPerson) => {

        if (data.agreementsEmail) {
            // console.log(data.agreementsEmail)
            postPersonIdAgreements([{
                id: data.id,
                tenantId: "621da32c-a4a9-400f-be33-73fdcc20e12f",
                agreement: true
            }])
        }

        if (disabledForm) {
            await handlePayment('ABR2');
            return;
        }

        try {
            const personNewData = {
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                eMail: data.eMail,
                phone: '+' + data.phone.replace(/\D+/g, ""),
            } as IPerson;

            const updateResult = await putPerson(personNewData) as any;

            if (updateResult.error) {
                dispatch(setAlertMsgStore({
                    title: 'Ошибка обновления данных покупателя.',
                    variant: 'danger'
                } as any));
                return;
            }

            // ym(29087940, 'reachGoal', 'dannie');
            await handlePayment('ABR2');

        } catch (error) {
            console.error('Ошибка при отправке данных:', error);
            dispatch(setAlertMsgStore({
                title: 'Произошла непредвиденная ошибка',
                variant: 'danger'
            } as any));
            setIsLoadingBank(false);
        }
    };

    const handlePayment = async (typeRid: string) => {
        try {
            setIsLoadingBank(true);

            const result = await getOrderLink({
                id: order.id,
                approveURL: `https://${window.location.host}/paytickets/order`,
                cancelURL: `https://${window.location.host}/paytickets/order`,
                declineURL: `https://${window.location.host}/paytickets/order`,
                typeRid
            }) as any;

            if (result.error) {
                dispatch(setAlertMsgStore({
                    title: 'Ошибка формирования ссылки для оплаты.',
                    variant: 'danger'
                } as any));
                return;
            }

            const dataLink = JSON.parse(result.data as string);

            if (dataLink.paid !== undefined) {
                navigate('/paytickets/order');
            } else {
                window.location.href = dataLink.bankLink;
            }

        } catch (error) {
            console.error('Ошибка при обработке платежа:', error);
            dispatch(setAlertMsgStore({
                title: 'Ошибка при обработке платежа',
                variant: 'danger'
            } as any));
        } finally {
            setIsLoadingBank(false);
        }
    };
    const setNewStatus = () => {
        if (order.orderStatus < 1) {
            postSetOrderStatus({
                id: order.id,
                status: {
                    orderStatus: 1,
                    clientId: data.id,
                }
            }).then((res: any) => {
                if (res.error) {
                    const basketItems = basket.map(item => {
                        const itemAssignment = sessionAssignments.find((cat: ICategoryAssignments) => cat.targetId === item.id) as ICategoryAssignments;
                        const sector = location.sectors.find((sector: ISector) => sector.seats.some((seat: ISeat) => seat.id === item.id));
                        const seat = sector ? sector.seats.find((seat: ISeat) => seat.id === item.id) : undefined;
                        return {
                            id: item.id,
                            price: itemAssignment.price,
                            color: itemAssignment.color ?? "black",
                            categoryName: itemAssignment.name,
                            row: seat ? seat.row : undefined,
                            seat: seat ? seat.place : undefined,
                            quantity: item.quantity,
                            priceCategoryAssignmentId: itemAssignment.id,
                            priceCategoryTarget: 3,
                            itemId: item.itemId,
                        };
                    });
                    const error = res.error
                    if ('data' in error && Array.isArray(error.data)) {
                        const itemsDelete = [] as any
                        error.data.forEach(async (item: any) => {
                            const itemBasket = basketItems.find((basketItem: any) => basketItem.itemId === item.id)
                            // "quantity": 1,
                            // "limit": 1,
                            // "occupied": 0
                            if (item.occupied === 0) {
                                return;
                            }
                            if (itemBasket) {
                                if (item.quantity >= itemBasket.quantity) {
                                    await deleteOrderItem(itemBasket.itemId).then(() => {
                                        getOrderItems(order.id).then((r: any) => {
                                            if (!r?.error) {
                                                const items = r.data
                                                dispatch(setSessionItemsInStore(items as any))
                                            }
                                            if (r?.error) {
                                                localStorage.removeItem('order')
                                                localStorage.removeItem('sessionId')
                                                dispatch(setOrderInStore(null as any))
                                            }
                                        })
                                    })
                                }
                            }
                            else {
                                const avaibleQuantity = item.limit - item.occupied;
                                console.log(avaibleQuantity)
                            }
                            setNewStatus()
                        })
                        dispatch(setDeleteItemsStore(itemsDelete))
                        getSessionAssignmentsMutation(session.id).then((r: any) => {
                            if (!r.error) {
                                dispatch(setSessionAssignmentsStore(r.data as any))
                            }
                        })

                        dispatch(setAlertMsgStore({ title: `Некоторые места уже забронированы, они исключены из вашего заказа.`, variant: 'danger' } as any))
                    }
                    return;
                }
                else {
                    dispatch(setOrderInStore(res.data as any))
                }
            })
        }

    }

    useEffect(() => {
        if (data) {
            setValue('id', data.id)
            setValue('phone', data.phone)
            setValue('firstName', data.firstName)
            setValue('lastName', data.lastName)
            setValue('eMail', data.eMail)
            setNewStatus()

            if (data.firstName && data.lastName && data.eMail) {
                setDisabledForm(true)
                // const orderString = localStorage.getItem('order') as string
                // const order = JSON.parse(orderString) as IOrder
                // console.log(order.orderStatus)
            }
        }
    }, [data])


    useEffect(() => {
        if (isLoadingGetOrderLink) {
            setIsLoadingBank(true)
        }
    }, [isLoadingGetOrderLink])

    const purchaseRules = () => {
        return (
            <span style={{ fontSize: '12px' }}>
                Я ознакомлен и согласен с <Link className="text-black" target="_blank" to="https://leningradcenter.ru/api/redirecturls/ticket-purchase-rules">Правилами покупки билетов правилами посещения мероприятия</Link>
            </span>
        )
    }

    const visitingPolicy = () => {
        return (
            <span style={{ fontSize: '12px' }}>
                Я ознакомлен и согласен с <Link className="text-black" target="_blank" to="https://leningradcenter.ru/api/redirecturls/visiting-rules">Правилами посещения Ленинград Центра</Link>
            </span>
        )
    }

    const agreementsEmail = () => {
        return (
            <span style={{ fontSize: '12px' }}>
                Согласен на получение информационной рассылки
            </span>
        )
    }

    return (
        <>
            {isLoadingPutPerson &&
                <FullScreenLoader message="Обновление данных покупателя..." />
            }
            {isLoadingOrderStatus &&
                <FullScreenLoader message="Обновление данных заказа..." />
            }

            <CertForm />

            {!isLoading ?

                <Form onSubmit={handleSubmit(submit)} className="d-grid gap-2">
                    <div style={{ fontSize: "12px" }}>
                        Чтобы купить билет на это событие, заполните анкету. Информация о вас будет доступна только организаторам этого события.
                    </div >
                    <FloatingLabel label="Телефон">
                        <Form.Control placeholder="Телефон" disabled={true} {...register('phone')} />
                    </FloatingLabel>
                    <div className="d-flex gap-1">
                        <FloatingLabel label="Имя">
                            <Form.Control placeholder="Имя" isInvalid={errors?.firstName ? true : false} disabled={disabledForm} {...register('firstName', { required: true })} />
                        </FloatingLabel>
                        <FloatingLabel label="Фамилия">
                            <Form.Control placeholder="Фамилия" isInvalid={errors?.lastName ? true : false} disabled={disabledForm}  {...register('lastName', { required: true })} />
                        </FloatingLabel>
                    </div>
                    <FloatingLabel label="E-mail">
                        <Form.Control
                            placeholder="E-mail"
                            isInvalid={!!errors?.eMail}
                            disabled={disabledForm}
                            {...register('eMail', {
                                required: true,
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Некорректный адрес электронной почты"
                                },
                                onChange: (e) => {
                                    const value = e.target.value.replace(/\s/g, ''); // удаляем все пробелы
                                    e.target.value = value; // обновляем значение в инпуте
                                    // React Hook Form сам обработает обновлённое значение
                                }
                            })}
                        />
                    </FloatingLabel>
                    {disabledForm &&
                        <Button variant="light" className="shadow" onClick={() => { setDisabledForm(false) }} >Изменить данные</Button>
                    }
                    <Button variant="light" className="shadow" size="sm" onClick={() => {
                        logOutTP()
                    }}>Выйти из профиля</Button>

                    <div>
                        <Form.Switch
                            label={purchaseRules()}
                            className="tpswith" isInvalid={errors?.payPolicy ? true : false}
                            {...register('payPolicy', { required: true })}
                        />
                        <Form.Switch
                            label={agreementsEmail()}
                            isInvalid={errors?.agreementsEmail ? true : false}
                            {...register('agreementsEmail')}
                        />
                        <Form.Switch
                            label={visitingPolicy()}
                            isInvalid={errors?.visitingPolicy ? true : false}
                            {...register('visitingPolicy', { required: true })}
                        />
                    </div>
                    <Button disabled={isLoadingBank} variant="dark" type="submit">
                        Оплатить {isLoadingBank && <Spinner size="sm" />}
                    </Button>
                </Form >
                :
                <Spinner className="spinner" variant="dark" />
            }
        </>
    )
}